import { Card } from "primereact/card"
import gpraStyles from "../../../styles/Participant-GPRA.module.css"
import { Button } from "primereact/button"
import { DateTime } from "luxon"

const GpraCardDetail = ({
  title,
  type,
  loading,
  completed_date,
  setShowSummary,
  setInterviewType,
}) => {
  const header = () => {
    return (
      <div className={gpraStyles.interviewCardHeader}>
        <h3 className={gpraStyles.ml1}>
          <b>{title}</b>
        </h3>
      </div>
    )
  }

  const completedDate = DateTime.fromISO(completed_date, {
    zone: "utc",
  }).toLocal()
  return (
    <Card className={gpraStyles.card} header={header}>
      <div className={gpraStyles.interviewCard}>
        <p>
          <b>Completed: </b>
          {loading ? (
            <i className="pi pi-spin pi-spinner"></i>
          ) : completedDate.year === 0 ? (
            "No date"
          ) : (
            completedDate.toLocaleString()
          )}
        </p>
      </div>
      <div className={gpraStyles.interviewCardButton}>
        <Button
          style={{ backgroundColor: "#8467ad", border: "none" }}
          label={"View summary"}
          onClick={() => {
            setInterviewType(type)
            setShowSummary(true)
          }}
        />
      </div>
    </Card>
  )
}
export default GpraCardDetail
